const desktopMediaQuery = window.matchMedia('(min-width: 768px)');

function placeProductAccordions(section) {
  const accordions = section.querySelector('.product-redesign__accordions');
  const desktopAnchor = section.querySelector('[data-product-accordions-desktop-anchor]');
  const mobileTarget = section.querySelector('[data-product-accordions-mobile-target]');

  if (!accordions || !desktopAnchor || !mobileTarget) return;

  const updatePlacement = () => {
    if (desktopMediaQuery.matches) {
      desktopAnchor.after(accordions);
    } else {
      mobileTarget.append(accordions);
    }
  };

  desktopMediaQuery.addEventListener('change', updatePlacement);
  updatePlacement();
}

document
  .querySelectorAll('[data-wetheme-section-type="template--product"]')
  .forEach(placeProductAccordions);
